import { useEffect, useMemo } from "react";
import { useScene } from "./use-scene";

/**
 * Continue the scene after delay when scene is unanswered and value
 * becomes true.
 * @param value
 * @param timeout
 */
export const useDelayedAnswer = (
  value: boolean,
  timeout = 0,
  customHandler?: () => void
) => {
  const scene = useScene();

  const canContinue = useMemo(() => {
    if (scene.isFinished) return false;

    return !scene.showingPoints && !scene.showingExplanation;
  }, [scene.showingPoints, scene.showingExplanation, scene.isFinished]);

  useEffect(() => {
    if (value && canContinue) {
      const _timeout = setTimeout(() => {
        if (customHandler) {
          customHandler?.();
        } else scene.lifecycle.continue();
      }, timeout);
      return () => {
        clearTimeout(_timeout);
      };
    }
    return undefined;
  }, [value, canContinue]);
};
